import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';

import type { FlexibilityPrices } from '@ps/survey-utils';
import { SupplierFlexibilityPricesDto } from './dtos/flexibility-prices.dto';
import { FlexibilityPricesMapper } from './mapper/flexibility-prices.mapper';

@Injectable({ providedIn: 'root' })
export class FlexibilityPricesApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);

  private readonly _baseUrl = `${this._env.pureSpectrum.url}`;

  public get(surveyId: number): Observable<FlexibilityPrices> {
    return this._http
      .get<SupplierFlexibilityPricesDto>(
        `${this._baseUrl}/supplier/getFlexibilityPricesParams/${surveyId}`,
      )
      .pipe(map((dto) => new FlexibilityPricesMapper().fromDto(dto)));
  }
}
